<template>
  <StyledCarouselNavigation
    :direction="direction"
    :return="this.return"
    :buttonId="buttonId"
    ref="targetEl"
  />
</template>

<script lang="ts">
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { defineComponent, computed } from "vue";
import StyledCarouselNavigation from "./styled/CarouselNavigation.vue";
import { composePopoverForm } from "@fresh8/ad-data-composition/src/popoverForm";

export default defineComponent({
  name: "CarouselNavigation",
  components: {
    StyledCarouselNavigation
  },
  props: {
    direction: {
      type: String,
      required: true
    },
    return: {
      type: Boolean
    }
  },
  setup() {
    const { adTemplate, brand } = injectBrand();
    const buttonId = computed(() => adTemplate.value.carouselNavigationButton);

    const { targetEl } = composePopoverForm("Navigation Button", [
      {
        type: "navigationButton",
        get: () => brand.value.adTemplate.carouselNavigationButton,
        set: (value: string) =>
          (brand.value.adTemplate.carouselNavigationButton = value)
      }
    ]);

    return {
      buttonId,
      targetEl
    };
  }
});
</script>

<style></style>
